function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  id: "oxy-social",
  d: "M204.278,215.592a6.779,6.779,0,0,1-4.8,1.986,7.388,7.388,0,0,1-2.6-.505,6.764,6.764,0,0,1-4.188-6.247V196.239l-4.369,4.369a6.805,6.805,0,0,1-4.8,1.986H168.28a6.788,6.788,0,0,1,0-13.576h12.457l13.937-13.937a6.763,6.763,0,0,1,11.554,4.766v14.587l30.51-30.51c-.505-.578-.975-1.155-1.517-1.7a30.052,30.052,0,0,0-42.5,0h0a30.051,30.051,0,0,0-42.5,42.5l42.5,42.5,42.5-42.5A30.076,30.076,0,0,0,243.2,176.6Z",
  transform: "translate(-141.425 -153.425)"
});

const SvgLogoOxySocial = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 102.566,
    height: 93.797,
    viewBox: "0 0 102.566 93.797",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgLogoOxySocial, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/logo-oxy-social.812fb98a.svg";
export { ForwardRef as ReactComponent };